import React from "react";
import TeamCard from "../../../../Shared/Components/TeamCard/TeamCard";

function Teams() {
  const teamMembers = [
    {
      name: "Anubha Mahajan",
      designation: "Co Founder",
      description:
       "Founder & Chairperson of Chronic Pain India and creator of Project Sunflower Lanyard, building India’s first inclusive medical emergency ID ecosystem. She has been invited twice to Rashtrapati Bhavan by the President of India in recognition of her leadership. Named a Diversability D-30 Disability Impact Honoree 2025, she is also Purple Ambassador at the International Purple Fest 2024. Dr. Mahajan has represented India at the UN Zero Project Conference and Global Disability Summit, shaping policy with NITI Aayog, UNESCO, WHO, and G20/C20 platforms.",
      imageUrl:
        "/Assets/Images/anubha.svg",
      alt:
        "Portrait of Dr. Anubha Mahajan, Co-Founder, seated indoors in a formal black outfit.",
      knowMore: "https://chronicpainindia.com/dr-anubha-mahajan"
    },
    // {
    //   name: "Kavya Mukhija",
    //   designation: "Co Founder",
    //   description:
    //     "COO of Chronic Pain India and Project Sunflower Lanyard, bringing lived experience with Arthrogryposis Multiplex Congenita. Global disability advocate, representing India at the UN, SAARC, UNICEF, Geneva, and the Global Disability Summit Youth. Holds an MSc in Disability, Design & Innovation from UCL as a Chevening Scholar and a Master's in Applied Psychology. Honoured with the prestigious Diana Award 2024 for her leadership and impact.",
    //   imageUrl:
    //     "/Assets/Images/kavya.svg",
    //   alt:
    //     "Photo of Kavya Mukhija, Co-Founder, seated in a wheelchair in front of a blue backdrop with white crown logos, wearing a black outfit with a scarf.",
    //   knowMore: "https://chronicpainindia.com/kavya-mukhija"
    // }
  ];

  const advisors = [
    {
      name: "Mr. S.C. Mahajan",
      designation: "Advisor | CFO & Trustee, Chronic Pain India",
      description: "Mechanical Engineer with over three decades of expertise in automotive and manufacturing industries. Formerly associated with Clutch Auto Ltd. and GKN Driveline, he now leads Durga Enterprises and Durga Industry. As CFO & Trustee of Chronic Pain India, he provides financial stewardship and strategic guidance. He brings deep technical and entrepreneurial insight to strengthen assistive technology innovation.",
      imageUrl:"/Assets/Images/scMahajan.svg",
      alt:
        "Photo of Mr. S.C. Mahajan, Advisor, wearing a dark checked suit and tie, standing in an outdoor decorated setting.",
    },
    // {
    //   name: "Mrs. Reena Mukhija",
    //   designation: "Advisor | Research Associate, ASTHA",
    //   description:
    //     "With 27 years of experience in the disability sector, she has worked extensively on community-based inclusion and empowerment. As Research Associate at ASTHA, she has supported projects that improve accessibility and disability rights. She is also the primary caregiver of Kavya Mukhija, shaping her advocacy with lived experience. Her unique blend of research and caregiving expertise strengthens PSL’s vision of dignity and safety for all.",
    //   imageUrl:
    //     "/Assets/Images/reena.svg",
    //   alt:
    //     "Portrait of Mrs. Reena Mukhija, Advisor, wearing glasses, a red patterned outfit, and mustard yellow scarf, standing against a teal background.",
    // }
  ];

  return (
    <div className="pb-24">
      <section className="w-full">
        {/* Hero Section */}
        <div className="flex flex-col md:flex-row items-center justify-between mb-8 bg-[#f5f0fc] px-20 sm:px-6 md:px-20 pt-10 md:pt-0">
          <div className="md:w-1/2 mb-6 md:mb-0">
            <h2 className="text-2xl sm:text-3xl font-bold text-left leading-snug">
              See Team <br /> Members
            </h2>
          </div>

          <div className="w-full md:w-1/2 flex justify-center items-end">
            <div className="relative md:pt-16">
              <img
                src="/Assets/Images/team.png"
                alt="Illustration of three people working together to place large puzzle pieces, symbolizing teamwork and collaboration."
                width={550}
                height={150}
                style={{ marginTop: "1rem" }}
              />
            </div>
          </div>
        </div>

        <div className="flex flex-col gap-[55px] px-4 sm:px-6 md:px-20 py-8 sm:py-10 md:py-12">
          {/* Team Grid */}
          <TeamCard heading="Core Team Members" teamMembers={teamMembers} />
          {/* Our Advisors */}
          <div className="mt-8">
            <TeamCard heading="Our Advisors" teamMembers={advisors} />
          </div>
        </div>
      </section>
    </div>
  );
}

export default Teams;
